import type { FC, InputHTMLAttributes } from "react";
import * as s from "./VariantListItem.module.scss";

type ImageProps = { image: { src: string; alt?: string } };
type VariantListItemProps = InputHTMLAttributes<HTMLInputElement> & ImageProps;

const VariantListItem: FC<VariantListItemProps> = ({ image }) => {
	return (
		<li>
			<img src={image.src} alt={image.alt} className={s.variantSymbol} />
		</li>
	);
};

export default VariantListItem;
